import {
  GET_LIST_THUCHINGOAILE,
  GET_LIST_THUCHINGOAILE_SUCCESS,
  GET_LIST_THUCHINGOAILE_FAILURE,
} from "actions/ThuChiNgoaiLe/actionTypes";

const initialState = {
  getListThuChiNgoaiLeLoading: false,
  posts: [],
  objList: {
    List: [],
  },
  totalRow: 0,
};

const getListThuChiNgoaiLe = (state, action) => ({
  ...state,
  getListThuChiNgoaiLeLoading: true,
});

const getListThuChiNgoaiLeSuccess = (state, action) => {
  return {
    ...state,
    getListThuChiNgoaiLeLoading: false,
    objList: action.payload,
  };
};

const getListThuChiNgoaiLeFailed = (state, action) => ({
  ...state,
  getListThuChiNgoaiLeLoading: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_THUCHINGOAILE:
      return getListThuChiNgoaiLe(state, action);
    case GET_LIST_THUCHINGOAILE_SUCCESS:
      return getListThuChiNgoaiLeSuccess(state, action);
    case GET_LIST_THUCHINGOAILE_FAILURE:
      return getListThuChiNgoaiLeFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
